import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

interface MetricpNameProps {
  active: number;
}

export const SubGroupName = styled(Typography)(() => ({
  marginTop: '10px',
  fontWeight: '500',
  color: 'rgba(1, 128, 148, 1)',
  textTransform: 'uppercase',
}));

export const MetricName = styled(Typography, {
  // Prevent custom prop from being forwarded to DOM
  shouldForwardProp: (prop) => prop !== 'active',
})<MetricpNameProps>(({ active }) => ({
  fontSize: '16px',
  lineHeight: '20.8px',
  cursor: 'pointer',
  color: active ? 'rgba(15, 182, 120, 1)' : 'initial',

  '&:hover': {
    color: 'rgba(15, 182, 120, 1)',
  },
}));

export const InnerContainer = styled(Box)(() => ({
  display: 'flex',
  gap: '10px',
  flexDirection: 'column',
  marginLeft: '5px',
}));

export const Container = styled(Box)(() => ({
  display: 'flex',
  gap: '10px',
  flexDirection: 'column',
  paddingBottom: '15px',
}));
